<template>
  <div :class="[`x1-1`, className || ``]">
    <div class="group-51">
      <div class="overlap-group-8">
        <bg :src="bgProps.src" :className="bgProps.className" />
        <img
          class="shape-4"
          src="/otplanding/shape-3@2x.png"
          alt="Shape"
        />
      </div>
    </div>
    <div class="text-8">
      <div class="instant-features-6 inter-bold-link-water-24px">Poslovođa</div>
      <p class="duis-aute-irure-dolo-7 inter-bold-gull-gray-18px">
        <span class="span-7 inter-bold-gull-gray-18px">eFakture - neograničeno<br /></span
        ><span class="span-7 inter-normal-gull-gray-18px"
          >kartice partnera, upravljanje lagerom<br />rasknjižavanje uplata po izvodu<br /></span
        ><span class="span-7 inter-bold-gull-gray-18px">povezano sa&nbsp;&nbsp;knjigovođom</span>
      </p>
    </div>
  </div>
</template>

<script>
import Bg from "./Bg";
export default {
  name: "X1",
  components: {
    Bg,
  },
  props: ["className", "bgProps"],
};
</script>

<style>
.x1-1 {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 228px;
  width: fit-content;
}

.group-51 {
  height: 64px;
  min-width: 64px;
  position: relative;
}

.overlap-group-8 {
  height: 64px;
  position: relative;
  width: 64px;
}

.shape-4 {
  height: 32px;
  left: 14px;
  position: absolute;
  top: 16px;
  width: 36px;
}

.text-8 {
  height: 150px;
  min-width: 325px;
  overflow: hidden;
  position: relative;
}

.instant-features-6 {
  left: 20px;
  letter-spacing: -0.25px;
  line-height: 34px;
  position: absolute;
  text-align: center;
  text-decoration: underline;
  top: 0;
  white-space: nowrap;
  width: 286px;
}

.duis-aute-irure-dolo-7 {
  left: 0;
  letter-spacing: -0.25px;
  line-height: 27px;
  position: absolute;
  text-align: center;
  top: 38px;
  width: 325px;
}

.x1-1.x1-2 {
  margin-left: unset;
}
</style>
